import { Dispatch, SetStateAction } from 'react'
import { UseFormReturn } from 'react-hook-form'
import useCourseCategories from '@hooks/useCourseCategories'
import useCourseAvailabilityFilters from '@hooks/useCourseAvailabilityFilters'
import { FiltersProps } from '@templates/ListPageLayout/Filters'
import { FilterState } from '@hooks/useItemsFilters'

const useMyCoursesFilters = (
  methods: UseFormReturn,
  setCourseFilters: Dispatch<SetStateAction<FilterState>>
): FiltersProps => {
  const {
    company: availabilityCompany,
    filial: availabilityFilial,
  } = useCourseAvailabilityFilters(methods, setCourseFilters)

  const courseCategoriesResponse = useCourseCategories()
  const { items: courseCategories = [], length = 0 } =
    courseCategoriesResponse.data || {}
  const courseCategoriesIsLoading = courseCategoriesResponse.isLoading

  const filters: FiltersProps = [
    {
      isLoading: courseCategoriesIsLoading,
      options: courseCategories,
      length,
      placeholder: 'Категория курса',
      isMulti: true,
      fieldName: 'courseCategory',
      dropdownWidth: 350,
    },
    availabilityCompany,
    availabilityFilial,
  ]

  return filters
}

export default useMyCoursesFilters
